import React from "react";
import {
    Container,
    Box,
    Card,
    CardContent,
    Typography,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Chip,
    Stack,
    Grid, Avatar
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faGavel,
    faHandshake,
    faBullhorn,
    faUsers,
    faComments,
    faBookOpen,
    faExclamationTriangle,
    faCheck,
    faLightbulb,
    faLeaf,
    faArrowRight,
    faQuoteLeft,
    faCircleInfo,
    faPeopleGroup,
    faBalanceScale
} from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "@others/title-section.layout";
//@ts-ignore
import photoJPG from "../../assets/images/others/jpg.png"

const POST20250404: React.FC = () => (
    <Container sx={{ mb: 8 }}>
        <SectionTitle title={"ESPACE INFORMATIONS DES HABITANTS"} />

        <Box mt={3}>
            <Typography variant="h5" fontWeight="bold" color="primary" textAlign="center" gutterBottom>
                L'association VLD
            </Typography>
            <Paper elevation={0} sx={{ bgcolor: "#f7fbff", p: { xs: 2, md: 4 }, borderRadius: 2, mb: 3 }}>
                <Typography variant="body1" paragraph>
                    Notre mouvement est né le 9 novembre 2021, jour où le Maire a annoncé à ses élus, son projet de donner
                    carte blanche à l’EPFIF dans le seul but de construire massivement.
                </Typography>
                <Typography variant="body1" paragraph>
                    Face à cette menace, nous avons dû réagir et vous appeler à refuser ce projet destructeur et irréversible
                    pour Bois-le-Roi. Notre alerte a permis une mobilisation historique lors du CM du 18 novembre 2021, contre
                    la signature de la convention avec l’EPFIF.
                </Typography>
                <Typography variant="body1" paragraph>
                    A partir du début de l'année 2022, la Majorité va multiplier les recrutements et les recours à tout-va aux
                    cabinets de conseils pour pallier ses insuffisances, une absence de méthode doublée d'un pilotage à vue.
                    Les projets annoncés sont au point mort.
                </Typography>
                <Typography variant="body1" paragraph>
                    Le Maire évoque une politique “volontariste” pour justifier la détérioration des finances communales, mais
                    les Bacots commencent à percevoir la réalité de sa gestion sans rigueur et l’absence de planification
                    budgétaire.
                </Typography>
                <Typography variant="body1" paragraph fontWeight="medium" color="secondary" sx={{ pl: 2 }}>
                    =&gt; Ainsi, pour continuer de vous informer et de vous alerter, nous avons créé l'association VLD.
                </Typography>
            </Paper>

            <Box mb={2}>
                <Typography variant="h6" color="primary" fontWeight="bold" gutterBottom>
                    Nos valeurs
                </Typography>
                <List dense sx={{ pl: 2 }}>
                    {[
                        "Un attachement fort à la démocratie,",
                        "L’écoute active, l’ouverture d’esprit,",
                        "Le partage des informations,",
                        "L’engagement,",
                        "La recherche du consensus,",
                        "Le sens de l’intérêt général."
                    ].map((text, i) => (
                        <ListItem key={i} disablePadding>
                            <ListItemIcon>
                                <FontAwesomeIcon icon={faLeaf} style={{ color: "#2196f3" }} />
                            </ListItemIcon>
                            <ListItemText primary={<Typography variant="body1">{text}</Typography>} />
                        </ListItem>
                    ))}
                </List>
            </Box>

            <Box mb={2}>
                <Typography variant="h6" color="primary" fontWeight="bold" gutterBottom>
                    Nos engagements
                </Typography>
                <List dense sx={{ pl: 2 }}>
                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faBullhorn} style={{ color: "#4caf50" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="body1">
                                    Agir pour renforcer l'engagement citoyen, la démocratie, la liberté d'expression et la transparence. Le
                                    sens de la démocratie commence par délivrer aux habitants une information utile, honnête et en toute
                                    transparence, leur permettant de comprendre les enjeux.
                                </Typography>
                            }
                        />
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faLeaf} style={{ color: "#81c784" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="body1">
                                    Agir pour préserver notre qualité de vie, la physionomie de Bois-le-Roi et son environnement
                                    exceptionnel. Cela passe par un urbanisme maîtrisé au service des habitants, avec le souci du
                                    développement durable, de la protection et de la préservation des espaces naturels.
                                </Typography>
                            }
                        />
                    </ListItem>
                </List>
            </Box>

            <Box mb={2}>
                <Typography variant="h6" color="primary" fontWeight="bold" gutterBottom>
                    Nos actions
                </Typography>
                <List dense sx={{ pl: 2 }}>
                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faBookOpen} style={{ color: "#ff9800" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="body1">
                                    Nous travaillons les dossiers, collaborons ouvertement avec toutes les associations, et menons un travail
                                    d'investigation permanent pour accéder aux informations, les analyser objectivement et les partager à tous.
                                    =&gt; Plus de 40 lettres d’informations sur tous les sujets majeurs pour Bois-le-Roi ont été publiées.
                                </Typography>
                            }
                        />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faGavel} style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText primary="Nous nous sommes opposés fermement au recours non maîtrisé à l'EPFIF." />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faBalanceScale} style={{ color: "#757575" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Nous avons dénoncé les méthodes antidémocratiques du Maire et sa politique du fait accompli qui met en tension
              les Bacots sur tous les projets non partagés (EPFIF, Crèche, PLH, PLUi, SMS...)"
                        />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faComments} style={{ color: "#00bfae" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <span>
                  Nous avons créé le groupe Facebook « Bois-le-Roi Infos -sans censure- » ouvert à vous tous, afin que vous puissiez
                  vous informer, échanger et communiquer. Toutes les opinions politiques peuvent s'exprimer librement.<br />
                  Nous préférons la liberté d'expression et la confrontation des idées à la censure.
                </span>
                            }
                        />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#d32f2f" }} />
                        </ListItemIcon>
                        <ListItemText primary="Nous avons pointé les choix contestables du dossier de la médiathèque." />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faPeopleGroup} style={{ color: "#e91e63" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Nous avons émis des doutes sur la réelle intention du Maire d'investir dans les équipements sportifs (pas de plan
                de financement, pas de planning et contre toute attente un chantage aux urnes)."
                        />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faArrowRight} style={{ color: "#9c27b0" }} />
                        </ListItemIcon>
                        <ListItemText primary="Nous avons proposé une alternative au choix contestable du site de construction de la crèche." />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#fbc02d" }} />
                        </ListItemIcon>
                        <ListItemText primary="Nous vous avons alertés sur la faillite des finances communales." />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faQuoteLeft} style={{ color: "#3f51b5" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Nous avons dénoncé la mascarade du projet BLR2030, et celle de la première version de la fiche communale du
              PLH (« J'ai voté pour mais je suis contre » dixit le Maire)."
                        />
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#00acc1" }} />
                        </ListItemIcon>
                        <ListItemText primary="Nous nous opposons aux secteurs de mixité sociale (SMS) du PLUi." />
                    </ListItem>
                </List>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box mb={2}>
                <Typography variant="h6" color="primary" fontWeight={700}>
                    A propos de l’enquête publique PLUi
                </Typography>
                <Typography variant="body1" paragraph>
                    Le 4 avril dernier se terminait l’enquête publique PLUi. Nous nous sommes associés aux autres associations
                    pour vous proposer un canal ponctuel de partage (infopluiblr.fr).
                    Rassembler des visions différentes dans une démarche commune pour vous permettre
                    d'avoir accès à l'information et vous faire votre propre opinion, c'est l'ADN de VLD.
                </Typography>
                <Typography variant="body1" paragraph>
                    Nous vous avons invités à vous exprimer à cette occasion. Et comme pour l’enquête publique organisée lors
                    de la modification n°3 du PLU, votre mobilisation a été exceptionnelle.
                </Typography>
                <Typography variant="body1" paragraph>
                    Alors que vous n’avez pas été véritablement associés à l’élaboration de ce projet, vous êtes plusieurs
                    centaines à y avoir contribué par vos remarques et vos propositions. Qui mieux que vous connaît sa rue, son
                    quartier, ses besoins ? En termes de logement, de mobilité, de patrimoine bâti ou paysager à protéger…
                </Typography>
                <Typography variant="body1" paragraph>
                    C’est aussi pour cela que l’association VLD a été créée, pour vous informer et vous donner la parole sans
                    restrictions.
                </Typography>
            </Box>

            <Box
                sx={{
                    bgcolor: "#f8f9fa",
                    borderLeft: "6px solid #3498db",
                    p: 2,
                    mb: 2,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" color="error" fontWeight="bold" gutterBottom>
                    Les secteurs de mixité sociale tels qu'ils ont été définis par le Maire
                    sont une atteinte inacceptable au droit de la propriété.
                </Typography>
                <Typography variant="body1">
                    Rappelons que le recours à ce dispositif et les conditions d’application ont été dévoilés pour la première fois
                    aux Bacots à l’occasion des réunions publiques, quelques jours seulement avant le premier arrêt du projet
                    voté au conseil d’agglomération le 27 juin 2024... Le Maire se justifie par l’obligation de réaliser des
                    logements sociaux, mais les autres évolutions de ce PLUi le permettent déjà.
                </Typography>
            </Box>

            <Typography variant="body1" paragraph fontWeight="medium" color="secondary">
                Nous avons demandé à la Présidente de la commission d'enquête
                de rendre un avis défavorable aux secteurs de mixité sociale.
            </Typography>
            <Typography variant="body1" paragraph>
                Au-delà de cette modification prioritaire, pour préserver notre commune d’une forte densification, mieux
                protéger notre patrimoine naturel et pour plus de clarté, nous avons également fait de nombreuses
                demandes, que vous pouvez retrouver via le lien :
                Un nouveau travail de fond, collaboratif, avec les différentes associations et les habitants sera nécessaire
                pour aboutir à un PLUi répondant véritablement aux enjeux environnementaux et légaux.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Box mb={3}>
                <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
                    Et la suite...
                </Typography>
                <Typography variant="body1" paragraph>
                    Le chemin est encore long mais vous êtes mobilisés et c’est un formidable espoir.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’association VLD et moi-même continueront à l’être, pour poursuivre le travail effectué ces dernières
                    années.
                </Typography>
                <Typography variant="body1" paragraph>
                    Il faut rétablir le dialogue, échanger et surtout écouter avec sincérité, travailler ensemble à proposer des
                    réponses concrètes. Les prochaines élections municipales nous donnent de nouvelles perspectives.<br />
                    Toutes les bonnes volontés sont les bienvenues. Rejoignez-nous.
                </Typography>
            </Box>

            <Box display="flex" justifyContent="center" alignItems="center" mt={5}>
                <Box
                    display="flex"
                    alignItems="center"
                    gap={3}
                    p={2}
                    bgcolor="#f3f5fa"
                    borderRadius={3}
                    boxShadow={2}
                >
                    <Box textAlign="right">
                        <Typography
                            variant="subtitle1"
                            fontWeight={700}
                            color="primary"
                            letterSpacing={1}
                        >
                            Jean-Philippe GUIBERT
                        </Typography>
                        <Typography
                            variant="body2"
                            fontStyle="italic"
                            color="text.secondary"
                        >
                            Président
                        </Typography>
                    </Box>
                    <Avatar
                        alt="Photo de Jean-Philippe GUIBERT"
                        src={photoJPG}
                        sx={{ width: 90, height: 90, boxShadow: 2, border: '2px solid #ddd' }}
                    />
                </Box>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Paper elevation={1} sx={{ bgcolor: "#f8fafc", p: 3, borderRadius: 3 }}>
                <Stack spacing={2}>
                    <Typography variant="h6" component="strong">
                        Légende des sigles
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                <Chip label="CM" color="primary" />
                                <Typography variant="body2" component="span">
                                    Conseil Municipal
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                <Chip label="EPFIF" color="primary" />
                                <Typography variant="body2" component="span">
                                    Établissement Foncier Public d’Île de France
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                <Chip label="SMS" color="primary" />
                                <Typography variant="body2" component="span">
                                    Secteurs de Mixité Sociale
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                <Chip label="PLH" color="primary" />
                                <Typography variant="body2" component="span">
                                    Programme Local de l'Habitat
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                <Chip label="PLUi" color="primary" />
                                <Typography variant="body2" component="span">
                                    Plan Local d'Urbanisme Intercommunal
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                <Chip label="VLD" color="primary" />
                                <Typography variant="body2" component="span">
                                    Association Vivre La Démocratie à BLR
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </Stack>
            </Paper>
        </Box>
    </Container>
);

export default POST20250404;